import { Share2, Trophy } from 'lucide-react';
import { Button } from '@fq/ui/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fq/ui/components/ui/dialog';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  eventName: string;
  picksMade: number;
  totalPicks: number;
  /** Invoked when the user picks "Share on X" — caller should close this
   * dialog and open the share dialog. */
  onShare: () => void;
};

export function SubmitPicksCelebrationDialog({
  open,
  onOpenChange,
  eventName,
  picksMade,
  totalPicks,
  onShare,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/15 ring-2 ring-amber-500/40">
            <Trophy className="h-7 w-7 text-amber-400" />
          </div>
          <DialogTitle className="text-center text-xl">
            You&rsquo;re locked in for {eventName}
          </DialogTitle>
          <DialogDescription className="text-center">
            {picksMade} / {totalPicks} picks made. Good luck &mdash; we&rsquo;ll
            score them as matches lock.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col-reverse sm:flex-row sm:justify-center gap-2 sm:gap-3 pt-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Done
          </Button>
          <Button onClick={onShare}>
            <Share2 className="h-4 w-4 mr-2" />
            Share on X
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
